import { useEffect, useState } from 'react'
import Input from "../../../DynamicComp/Input";
import Productmasterimg from './Productmasterimg';

const NewVariant = () => {
    const [childImages, setChildImages] = useState([]);
    const [formData, setFormData] = useState({
    productName: '',
    purchasePriceIncludeGST: '',
    selling_Price: 0,
    cgst_percent: 0,
    cgst: 0,
    sgstPer: 0,
    sgst: 0,
    igstPer: 0,
    igst: 0,
    sellingPriceGST: 0,
    discountPercent: 0,
    discountAmount: 0,
    netPrice: 0,
    MRP: 0,
    initial_stock: 0,
    height: 0,
    width: 0,
    breadth: 0,
    weight: 0,
  });
  const inputClassName = "w-full px-2 py-1 text-sm border border-gray-300 rounded-md shadow-sm placeholder-gray-700";
    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
      const handleImagesUpdate = (updatedImages) => {
        setChildImages(updatedImages);
    };
    const handlesubmit=(e)=>{
     e.preventDefault();
     console.log("form data",formData)
     const formDataToSend = new FormData();

  const imagesData = childImages.map((img, idx) => ({
    file_name: img.file_name || '', 
    displayOrder: img.displayOrder || idx + 1,
    description: img.description || '',
    isNew: img.file instanceof File || img.isNew 
  }));

  formDataToSend.append('images_data', JSON.stringify(imagesData));

  childImages.forEach((img) => {
    if (img.file instanceof File) {
      formDataToSend.append('image_files', img.file);
    }
  });
  console.log("formdatatosend image",formDataToSend)
    }
     const calculatePercentageAmount = (baseValue, percentage) => {
            const numericBase = parseFloat(baseValue) || 0;
            const numericPercent = parseFloat(percentage) || 0;
    
            // The correct formula is (base * percent) / 100
            return (numericBase * numericPercent) / 100;
        };
    
        useEffect(() => {
            // Use the new function to calculate each GST amount individually.
            const calculated_cgst = calculatePercentageAmount(formData.selling_Price, formData.cgst_percent);
            const calculated_sgst = calculatePercentageAmount(formData.selling_Price, formData.sgstPer);
            const calculated_igst = calculatePercentageAmount(formData.selling_Price, formData.igstPer);
    
            // Sum the calculated GST amounts to get the total GST.
            const total_gst_amount = calculated_cgst + calculated_sgst + calculated_igst;
            
            // Add the total GST to the base selling price.
            const selling_price_with_gst = (parseFloat(formData.selling_Price) || 0) + total_gst_amount;
    
            setFormData((prev) => ({
                ...prev,
                cgst: calculated_cgst.toFixed(2),
                sgst: calculated_sgst.toFixed(2),
                igst: calculated_igst.toFixed(2),
                sellingPriceGST: selling_price_with_gst.toFixed(2),
            }));
        }, [formData.selling_Price, formData.cgst_percent, formData.sgstPer, formData.igstPer]);
    
      useEffect(() => {
            // Calculate the discount amount based on the Selling Price with GST and the new discountPercent field.
            const calculatedDiscount = calculatePercentageAmount(formData.sellingPriceGST, formData.discountPercent);
            
            const basePriceWithGst = parseFloat(formData.sellingPriceGST) || 0;
    
            // Calculate the final net price.
            const calculatedNetPrice = basePriceWithGst - calculatedDiscount;
    
            setFormData((prev) => ({
                ...prev,
                discountAmount: calculatedDiscount.toFixed(2),
                netPrice: calculatedNetPrice.toFixed(2),
            }));
        }, [formData.sellingPriceGST, formData.discountPercent]);
  return (
   <div className="bg-white ">
         <h2 className="text-xl font-semibold mb-4">New Variant</h2>
         <form onSubmit={(e)=>handlesubmit(e)}>
    <div>
                                               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                                                       <div className="col-span-1">
                                                                           <label htmlFor="title" className="block text-gray-700 font-semibold mb-2">Title</label>
                                                     <Input type="text"name="productName"value={formData.productName || ""}onChange={handleChange}placeholder="Enter Product Name"required={false}className={inputClassName} disabled={true}/></div>
                                                   <div className="col-span-1"><Input type="text" label="Purchase Price Included GST" name="purchasePriceIncludeGST" value={formData.purchasePriceIncludeGST} onChange={handleChange} placeholder="Enter Purchase Price" required="true" labelColor="text-gray-700 font-semibold" className={inputClassName} /></div>
                                                   <div className="col-span-1"><Input type="text" label="Selling Price" name="selling_Price" value={formData.selling_Price} onChange={handleChange} placeholder="Enter Selling Price" className={inputClassName} required="true" /></div>
                                                   <div className="col-span-1"><Input type="text" label="CGST %" name="cgst_percent" value={formData.cgst_percent} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                                   <div className="col-span-1"><Input type="text" label="CGST ₹" name="cgst" value={formData.cgst} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" disabled={true} /></div>
                                                   <div className="col-span-1"><Input type="text" label="SGST %" name="sgstPer" value={formData.sgstPer} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                                   <div className="col-span-1"><Input type="text" label="SGST ₹" name="sgst" value={formData.sgst} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" disabled={true} /></div>
                                                   <div className="col-span-1"><Input type="text" label="IGST %" name="igstPer" value={formData.igstPer} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                                   <div className="col-span-1"><Input type="text" label="IGST ₹" name="igst" value={formData.igst} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" disabled={true} /></div>
                                                   <div className="col-span-1"><Input type="text" label="Selling Price With GST" name="sellingPriceGST" value={formData.sellingPriceGST} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                                  <div className="col-span-1"> <Input type="text" label="Discount %"  name="discountPercent" value={formData.discountPercent} onChange={handleChange} placeholder="0.00" required="true"  labelColor="text-gray-700 font-semibold" className={inputClassName} /></div>
                                                  <div className="col-span-1"><Input  type="text" label="Discount Amount (₹)" name="discountAmount" value={formData.discountAmount} onChange={handleChange} placeholder="Calculated Discount" required={false}labelColor="text-gray-700 font-semibold"   className={inputClassName} disabled={true} /></div>
                                                  <div className="col-span-1">  <Input type="text" label="Net Price" name="netPrice" value={formData.netPrice}   onChange={handleChange} placeholder="Final Price"  required={false}labelColor="text-gray-700 font-semibold" className={inputClassName} disabled={true} /></div>
                                                 <div className="col-span-1"><Input type="text" label="MRP" name="MRP" value={formData.MRP} onChange={handleChange} placeholder="MRP" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
   <div className="col-span-1"> <Input  type="text" label="Stock" name="initial_stock" value={formData.initial_stock} onChange={handleChange} placeholder="Enter stock" required="true" labelColor="text-gray-700 font-semibold" className={inputClassName}  /></div>
   </div>
   
   <div className="mt-6">
       
       <h1 className="text-lg font-semibold text-gray-800 mb-2">Dimension</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
   <div className="col-span-1"><Input type="text" label="Height(cm)" name="height"  value={formData.height} onChange={handleChange} placeholder="Enter height" required="true" labelColor="text-gray-700 font-semibold" className={inputClassName}  /></div>
   <div className="col-span-1"><Input type="text" label="Width(cm)" name="width" value={formData.width} onChange={handleChange} placeholder="Enter width"  required="true" labelColor="text-gray-700 font-semibold" className={inputClassName}  /></div>
   <div className="col-span-1"> <Input  type="text" label="Breadth(cm)" name="breadth" value={formData.breadth} onChange={handleChange}  placeholder="Enter breadth" required="true" labelColor="text-gray-700 font-semibold"   className={inputClassName}  /></div>
   
   <div className="col-span-1"> <Input type="text" label="Weight(grams)" name="weight" value={formData.weight} onChange={handleChange} placeholder="Enter weight" required="true" labelColor="text-gray-700 font-semibold" className={inputClassName}  /></div>
   </div>
   </div>
   <div className="col-span-5 mt-6">
                               <div className="bg-white p-6 rounded-xl shadow-lg w-full overflow-x-auto mb-8">
                                   <Productmasterimg
                                       productId={null}
                                       onImagesUpdate={handleImagesUpdate}
                                       initialImages={childImages}
                                       key={'new'}
                                   />
                               </div>
                           </div>
   
         </div>      
   
           <div className="flex justify-end gap-2">
             <button
               type="submit"
               className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
             >
              Submit
             </button>
           </div>
         </form>
       </div>
  )
}

export default NewVariant
